import EmptyIcon from '../assets/icons/empty-doc-light.svg';
import { FC } from 'react';

const EmptyDocLight: FC<{ className?: string }> = ({ className = '' }) => {
  return <EmptyIcon className={className} />;
};

export default EmptyDocLight;
